import { Layers, ChevronRight } from 'react-feather'
import { FormattedMessage } from 'react-intl'

export default [
    {
        id: 'petFood',
        title: <FormattedMessage id='PET FOOD' />,
        icon: <Layers />,

        children: [
            {
                id: 'poultryFeed',
                title: <FormattedMessage id='Hero Dog' />,
                icon: <ChevronRight />,
                navLink: '/heroDog'
            }, 

            {
                id: 'wonderCat',
                title: <FormattedMessage id='Wonder Cat' />,
                icon: <ChevronRight />,
                navLink: '/wonderCat'
            }
        ]
    }
]